import React, { useEffect, useState } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import "../index.css";
import { Form, Stack } from "react-bootstrap";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import ValidationSchema from "../../../components/Common/ValidationSchema";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserManagementData } from "../../../redux/slice/UserManagementSlice";
import { toast } from "react-toastify";
import { usePic } from "../../../context/PicProvider";
import { createReportGroup } from "../../../redux/slice/ReportsSlice";
import CustomAutocomplete from "../../../components/Common/MUI/CustomAutocomplete";
import {
  fetchGroupDataById,
  updateGroupDetails,
} from "../../../redux/slice/ReportsListingSlice";
const CreateGroupReport = () => {
  const initialValues = {
    group_name: "",
    group_member: null,
  };
  const { UserManagementData } = useSelector((state) => state.USERMANAGEMENT);
  const [search, setSearch] = useState(null);
  const [nameData, setNameData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [manageButton, setManageButton] = useState(null);
  const { setIsLoading } = usePic();
  const {
    values,
    handleBlur,
    handleChange,
    setValues,
    errors,
    touched,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.createReport,
    onSubmit: async (values) => {
      setIsLoading(true);
      let res;
      if (id) {
        res = await dispatch(updateGroupDetails({ ...values, id: id }));
      } else {
        res = await dispatch(createReportGroup(values));
      }
      setIsLoading(false);
      if (res?.payload?.status === 200) {
        navigate("/reports");
      }
    },
  });

  const addGroupHandler = (data) => {
    if (Object.keys(data).length === 0) {
      return;
    }
    const existingGroup = nameData.find(
      (curElm) => curElm.user_id === data._id
    );
    if (existingGroup) {
      toast.error("Group already exist");
      setSearch("");
      return;
    }
    const payData = {
      user_id: data._id,
      full_name: data.first_name + data.last_name,
      assigned_role: data.assigned_role,
    };
    setNameData((prev) => [...prev, payData]);
    setSearch(null);
    setValues({
      ...values,
      group_member: [...nameData, payData],
    });
  };

  const getNameDataFromList = (data) => {
    setSearch(data);
  };

  const removeGroup = (groupId) => {
    const filterName = nameData.filter((curElm) => curElm.user_id !== groupId);
    setNameData(filterName);
    setValues({
      ...values,
      group_member: filterName,
    });
    setManageButton(null);
  };

  useEffect(() => {
    dispatch(fetchUserManagementData());
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(fetchGroupDataById(id))
        .then((response) => {
          if (response.payload) {
            const { group_name, group_member } = response.payload.data;
            setValues({
              ...values,
              group_name: group_name,
              group_member: group_member,
            });
            setNameData(group_member); // Update nameData state with group members
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [dispatch, id]);

  return (
    <div className="flex-grow-1 bg-white d-flex flex-column popup-layout">
      <div
        className="position-sticky bg-white header-section"
        style={{ zIndex: 1 }}
      >
        <h4 className="text-center fw-bold m-0">
          {id ? "Update" : "Create A"} Report Group
        </h4>
        <hr className="my-3 my-md-4" />
      </div>
      <Form
        className="pt-4 flex-grow-1 d-flex flex-column"
        onSubmit={handleSubmit}
      >
        <Stack>
          <Form.Group className="mb-3" controlId="formBasicGroupName">
            <Form.Control
              type="text"
              name="group_name"
              value={values.group_name}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Group Name"
            />
            {errors.group_name && touched.group_name && (
              <p className="text-danger mt-1 mb-0">{errors.group_name} </p>
            )}
          </Form.Group>
          <div className="d-flex gap-3 align-items-center">
            <CustomAutocomplete
              value={search}
              onValueChange={(value) => getNameDataFromList(value)}
              textProps={{
                placeholder: "Search",
                variant: "outlined",
                name: "personOfTreatment",
              }}
              autoCompleteProps={{ disableClearable: true }}
              options={UserManagementData ?? []}
              showEndAdornment={false}
              noOptionsText="No group options"
              getOptionLabel={(option) =>
                `${option.first_name || ""} ${option.last_name || ""}`.trim()
              }
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              sx={{}}
            />
            <button
              className={`btn ${search ? "btn-primary" : "btn-secondary"}`}
              type="button"
              onClick={() => addGroupHandler(search)}
              disabled={search ? false : true}
            >
              Add to Group
            </button>
          </div>
          <hr />
          <div className="d-flex flex-column gap-3">
            <h6 className="fw-bold m-0">In this Group</h6>
            {nameData.length > 0 && (
              <div className="d-flex gap-3 flex-wrap">
                {nameData.map((curElm, index) => {
                  const isActive = manageButton === index + 1;
                  const border = isActive
                    ? "1px solid var(--bs-primary)"
                    : "1px solid #A8A8BD";
                  return (
                    <div
                      className="position-relative"
                      name="group_member"
                      key={index}
                    >
                      <button
                        // className={`w-100 btn ${
                        //   manageButton === index + 1
                        //     ? "text-primary"
                        //     : "text-black-50"
                        // }`}
                        className={`w-100 border btn ${
                          manageButton === index + 1
                            ? "border-primary text-primary"
                            : "text-black-50"
                        }`}
                        style={{
                          border,
                        }}
                        type="button"
                        onClick={() => setManageButton(index + 1)}
                      >
                        {curElm.full_name}
                      </button>
                      {manageButton === index + 1 && (
                        <span
                          className={`close-button-span ${
                            manageButton === index + 1 ? "text-primary" : ""
                          }`}
                        >
                          <IoIosCloseCircleOutline
                            className="cursor text_gray"
                            onClick={() => removeGroup(curElm.user_id)}
                            size={25}
                          />
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            {errors.group_member && touched.group_member && (
              <p className="text-danger mt-1 mb-0">{errors.group_member} </p>
            )}
          </div>
        </Stack>
        <div className="position-sticky bg-white footer-section">
          <hr />
          <div className="d-flex align-items-end justify-content-end gap-3 flex-wrap-reverse">
            <NavLink
              className="btn btn-dark flex-grow-1 flex-sm-grow-0"
              to="/reports"
            >
              Cancel
            </NavLink>
            <button className="btn-primary btn p-auto px-sm-5 flex-grow-1 flex-sm-grow-0">
              {id ? "Update " : "Save "}Changes
            </button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateGroupReport;
